import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, Column } from '../components/ui/Table';
import { Plus, Search, BadgeCheck, Ban } from 'lucide-react';
import { TaxProfileForm } from '../components/TaxProfileForm';
interface Tax {
  id: string;
  code: string;
  name: string;
  type: string;
  status: 'active' | 'inactive';
}
export function TaxSetup() {
  const [isCreating, setIsCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const taxes: Tax[] = [{
    id: '1',
    code: 'TAX-001',
    name: 'Value Added Tax',
    type: 'VAT',
    status: 'active'
  }, {
    id: '2',
    code: 'TAX-002',
    name: 'Goods and Services Tax',
    type: 'GST',
    status: 'active'
  }, {
    id: '3',
    code: 'TAX-003',
    name: 'Service Tax',
    type: 'Service Tax',
    status: 'active'
  }, {
    id: '4',
    code: 'TAX-004',
    name: 'Withholding Tax',
    type: 'Withholding',
    status: 'active'
  }, {
    id: '5',
    code: 'TAX-005',
    name: 'State Sales Tax',
    type: 'Sales Tax',
    status: 'active'
  }, {
    id: '6',
    code: 'TAX-006',
    name: 'Legacy Tax Code',
    type: 'VAT',
    status: 'inactive'
  }];
  const filteredTaxes = taxes.filter(t => t.name.toLowerCase().includes(searchQuery.toLowerCase()) || t.code.toLowerCase().includes(searchQuery.toLowerCase()) || t.type.toLowerCase().includes(searchQuery.toLowerCase()));
  const columns: Column<Tax>[] = [{
    key: 'code',
    label: 'Tax Code'
  }, {
    key: 'name',
    label: 'Tax Name',
    render: item => <span className="font-medium text-gray-900" data-id="element-2244">{item.name}</span>
  }, {
    key: 'type',
    label: 'Tax Type'
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2245">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-2246" /> : <Ban className="w-3 h-3 mr-1" data-id="element-2247" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }];
  if (isCreating) {
    return <TaxProfileForm onBack={() => setIsCreating(false)} onSave={() => {
      // In a real app, this would save the data
      setIsCreating(false);
    }} data-id="element-2248" />;
  }
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2249">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2250">
        <div data-id="element-2251">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2252">
            Tax Setup
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2253">
            Configure tax jurisdictions, rates, and applicability rules for
            products.
          </p>
        </div>
        <Button size="lg" className="shadow-sm" onClick={() => setIsCreating(true)} data-id="element-2254">
          <Plus className="mr-2 h-5 w-5" data-id="element-2255" />
          Add New Tax
        </Button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2256">
        <div className="relative" data-id="element-2257">
          <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2258" />
          <Input placeholder="Search taxes by code, name, or type..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2259" />
        </div>
      </div>

      {/* Table */}
      <Table columns={columns} data={filteredTaxes} onRowClick={tax => console.log('Clicked tax:', tax)} keyExtractor={item => item.id} data-id="element-2260" />
    </div>;
}